module.exports = __webpack_public_path__ + "img/批量提交.81b27916.svg";